import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import ReconnectingWebsocket from "reconnecting-websocket";
import xamatron from "xamatron";
var Client = /** @class */ (function (_super) {
    tslib_1.__extends(Client, _super);
    function Client() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connected = false;
        _this.deviceName = null;
        _this.deviceKey = null;
        _this.calendars = null;
        _this.onError = null;
        _this.pingInterval = 60 * 1000;
        return _this;
    }
    Client.prototype.created = function () {
        var _this = this;
        var url = (window.location.protocol == "https:" ? "wss:" : "ws:")
            + "//" + window.location.host + "/api/websocket";
        this.sock = new ReconnectingWebsocket(url);
        this.sock.onopen = function (e) { return _this.onopen(); };
        this.sock.onmessage = function (e) { return _this.onmessage(e); };
        this.sock.onclose = function (e) { return _this.onclose(e); };
    };
    Client.prototype.send = function (msg) {
        this.sock.send(JSON.stringify(msg));
    };
    Client.prototype.onopen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deviceKey, result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deviceKey = (location.href.match(/[?&]devicekey=([^&]+)/) || [])[1] || null;
                        if (!!deviceKey) return [3 /*break*/, 2];
                        if (!xamatron.enabled) return [3 /*break*/, 2];
                        return [4 /*yield*/, xamatron.bridge.invoke("Avenla.OfficeTools.GetDeviceKey", {})];
                    case 1:
                        result = _a.sent();
                        console.log("Result: " + JSON.stringify(result));
                        if (result.source == "external" && this.onError) {
                            this.onError("Loaded device key from external storage.");
                        }
                        if (result.key)
                            deviceKey = result.key;
                        _a.label = 2;
                    case 2:
                        if (!deviceKey) {
                            if (this.onError)
                                this.onError("Device key is not set. Cannot connect.");
                            return [2 /*return*/];
                        }
                        this.deviceKey = deviceKey;
                        this.send({
                            $type: "Authenticate",
                            deviceKey: this.deviceKey,
                        });
                        if (this.pingIntervalHandle)
                            clearInterval(this.pingIntervalHandle);
                        this.pingIntervalHandle = setInterval(function () { return _this.sendPing(); }, this.pingInterval);
                        this.connected = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Client.prototype.onmessage = function (e) {
        var msg = JSON.parse(e.data);
        var handler = this["handle_" + msg.$type];
        if (handler)
            handler(msg);
        else
            console.error("Unsupported message", msg);
    };
    Client.prototype.onclose = function (e) {
        this.connected = false;
        console.log(e);
        if (this.onError)
            this.onError(e.reason);
        if (this.pingIntervalHandle) {
            clearInterval(this.pingIntervalHandle);
            this.pingIntervalHandle = null;
        }
        if (e.code == 1002)
            alert(e.reason);
    };
    Client.prototype.sendPing = function () {
        this.send({ $type: "Ping" });
    };
    Client.prototype.handle_Ping = function (msg) {
        this.send({ $type: "Pong" });
    };
    Client.prototype.handle_DeviceInfo = function (msg) {
        var _this = this;
        var e_1, _a;
        this.deviceName = msg.name;
        try {
            for (var _b = tslib_1.__values(msg.calendars), _c = _b.next(); !_c.done; _c = _b.next()) {
                var calendar = _c.value;
                calendar.color = calendar.color || "#fe5000";
                calendar.events = null;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.calendars = msg.calendars;
        if (this.pingInterval != msg.pingInterval) {
            this.pingInterval = msg.pingInterval;
            if (this.pingIntervalHandle)
                clearInterval(this.pingIntervalHandle);
            this.pingIntervalHandle = setInterval(function () { return _this.sendPing(); }, this.pingInterval);
        }
    };
    Client.prototype.handle_CalendarEvents = function (msg) {
        var e_2, _a, e_3, _b;
        if (!this.calendars)
            return;
        try {
            for (var _c = tslib_1.__values(this.calendars.filter(function (d) { return d.calendarId == msg.calendarId; })), _d = _c.next(); !_d.done; _d = _c.next()) {
                var cal = _d.value;
                try {
                    for (var _e = tslib_1.__values(msg.events), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var ev = _f.value;
                        ev.start = new Date(ev.start);
                        ev.end = new Date(ev.end);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                msg.events.sort(function (a, b) { return a.start.getTime() - b.start.getTime(); });
                cal.events = msg.events;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Client = tslib_1.__decorate([
        Component
    ], Client);
    return Client;
}(Vue));
export default new Client();



//////////////////
// WEBPACK FOOTER
// ./app/ts/client.ts
// module id = 225
// module chunks = 0